export const APPEARANCE = {
  default: 'default',
  error: 'error',
};
